import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  FormErrorMessage,
  useToast,
  useDisclosure,
  Box,
  Text,
  Select,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

import { getOpsList, assignOpsToMerchant } from "../../../api/merchants";
import { Loader } from "components/Loader/loader";

export function AssignOps({ row, fetchData, filterQuery }) {
  const finalRef = React.useRef(null);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [opsList, setOpsList] = useState([]);
  const toast = useToast();
  const [openLoader, setOpenLoader] = useState(false);

  const {
    register,
    handleSubmit,
    formState,
    setValue,
    watch,
    reset,
  } = useForm({
    defaultValues: {
      opsUser: "",
    },
  });

  const getOpsDropdown = async () => {
    const res = await getOpsList(toast);
    return res;
  };

  const { errors } = formState;
  const form = watch();
  const onError = (errors) => console.log(errors);

  const handelSubmit = async (data) => {
    setOpenLoader(true);

    const payload = {
      ops_id: form["opsUser"] === "" ? null : form["opsUser"],
      merchant_id: row._id,
    };

    const res = await assignOpsToMerchant(payload, toast);

    if (res) {
      toast({
        status: "success",
        title: "Success.",
        description: res.msg || "Account manager assigned successfully",
      });
      onCloseModal();
    }
    setOpenLoader(false);
  };

  const onCloseModal = () => {
    reset();
    onClose();
    fetchData(filterQuery);
  };

  useEffect(() => {
    register("opsUser");
    if (isOpen) {
      setOpenLoader(true);
      getOpsDropdown().then((res) => {
        setOpsList(res?.data || []);
        setOpenLoader(false);
      });
    }
  }, [isOpen]);

  return (
    <>
      <Box
        display={"flex"}
        alignItems={"center"}
        width={"100%"}
        cursor={"pointer"}
        onClick={onOpen}
      >
        <Text onClick={onOpen}>Assign Account Manager</Text>
      </Box>
      <Modal
        isCentered
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onCloseModal}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Assign Account Manager</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Loader isLoading={openLoader} />
            <FormControl isInvalid={!!errors.opsUser}>
              <FormLabel fontSize={12} fontWeight={"semibold"}>
                Account Manager
              </FormLabel>
              <Select
                onChange={(e) => {
                  setValue("opsUser", e.target.value);
                }}
                value={form["opsUser"]}
                placeholder="Select account manager or leave empty to unassign"
              >
                {opsList?.map((ops) => (
                  <option key={ops._id} value={ops._id}>
                    {ops.username}
                  </option>
                ))}
              </Select>
              <FormErrorMessage>{errors.opsUser?.message}</FormErrorMessage>
            </FormControl>
          </ModalBody>
          <ModalFooter gap={4}>
            <Button
              colorScheme="white"
              color={"#3182ce"}
              size="sm"
              onClick={onCloseModal}
            >
              Cancel
            </Button>
            <Button
              onClick={handleSubmit(handelSubmit, onError)}
              size="sm"
              color={"white"}
              colorScheme="blue"
            >
              Save
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
